<template>
    <div>
        <transition v-if="!(stripeOpen || vippsOpen)" name="fade">
            <div class="auth-modal" id="payment-popup-modal">
                <div class="modal-backdrop" @click="closeByBackdrop">
                    <div class="modal-content relative">
                        <InnerLoader v-if="isLoading" :z-index="999" />
                        <NoPaymentOverlay v-if="!isLoading" @close="closeModal" :z-index="999" />

                        <div class="modal-header" style="border: none">
                            <div class="text-right">
                                <i @click="closeModal" class="fas fa-times text-xl shadow-text-none cursor-pointer"></i>
                            </div>
                        </div>

                        <div class="modal-body">
                            <div class="text-center auth-popup-header payment-popup-header">
                                <h2 v-if="!isTeacher" class="text-xl md:text-3xl my-1 shadow-text-none">
                                    {{ paymentTitle ? paymentTitle : translate('purchase_header_upgrade') }}
                                </h2>
                                <h2 v-else class="text-xl md:text-3xl my-1 shadow-text-none">
                                    {{ $t('teacher_purchase_header') }}
                                </h2>
                                <h4
                                    v-if="!isTeacher"
                                    class="mb-0 shadow-text-none text-sm md:text-lg mt-0 font-thin px-4"
                                >
                                    {{ description }}
                                </h4>
                                <h4 v-else class="mb-0 shadow-text-none text-sm md:text-lg mt-0 font-thin px-4">
                                    {{
                                        isTeacherPlus
                                            ? $t('teacher_purchase_description_plus')
                                            : $t('teacher_purchase_description_basic')
                                    }}
                                </h4>
                            </div>
                            <div v-if="!isTeacher" id="btn-group-mobile" class="text-center py-5">
                                <div class="btn-group">
                                    <a
                                        @click="fetchUpgrade('subscription')"
                                        :class="{
                                            active: isShowSubscriptionPlan,
                                            'font-size-14 md:font-size-16': true
                                        }"
                                        id="btn-subscription-plan"
                                    >
                                        <div class="flex items-center">
                                            <span>{{ $t('purchase_subscription_plan') }}</span>
                                        </div>
                                    </a>
                                    <a
                                        @click="fetchUpgrade('24hour')"
                                        :class="{
                                            active: !isShowSubscriptionPlan,
                                            'font-size-14 md:font-size-16': true
                                        }"
                                        id="btn-hour-access"
                                    >
                                        <div class="flex items-center">
                                            <span>{{ $t('purchase_header_24hour') }}</span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div
                                :class="`${!isTeacher ? 'max-w-xl' : 'max-w-teacher'}`"
                                class="flex plan-block m-auto"
                                id="d-group-access"
                            >
                                <div
                                    v-if="subscripeSelected"
                                    id="subscription-plan"
                                    class="flex w-full flex-col items-center justify-end col-xl-4 col-md-12 px-3 pb-3"
                                >
                                    <div class="highlight-mark items-center text-center">
                                        <span v-if="isTeacher">
                                            <i class="fas fa-graduation-cap"></i>
                                            {{ $t('teacher_purchase_school_access_plus') }}
                                        </span>
                                        <span v-else>
                                            {{ $t('purchase_subscription_best_value') }}
                                        </span>
                                    </div>
                                    <div
                                        :class="{ 'disabled-plan': isTeacherPlus }"
                                        class="plan-item purchase-plan-block text-dark-charcoal w-full text-center system-border"
                                    >
                                        <h1 class="text-center text-2xl shadow-text-none mb-0 mt-2">
                                            {{
                                                isTeacher
                                                    ? $t('teacher_purchase_subscription_plan')
                                                    : $t('purchase_subscription_plan')
                                            }}
                                        </h1>
                                        <p
                                            class="text-center text-sm md:text-lg shadow-text-none mt-2 mb-3"
                                            v-html="
                                                isTeacher
                                                    ? $t('teacher_purchase_subscription_plan_description')
                                                    : $t('purchase_subscription_plan_description')
                                            "
                                        ></p>

                                        <div
                                            class="flex flex-col w-full justify-center items-center px-2 py-1 plan-title system-border-top system-border-bottom"
                                        >
                                            <div class="flex">
                                                <div v-if="!isTeacher">
                                                    <button
                                                        @click="selectPrev('subscripePriceText', 'subscripeIndex')"
                                                        :class="{
                                                            'system-primary-text-color': true,
                                                            'text-3xl payment-control-btn': true,
                                                            'cursor-pointer': !subscripeIndex == 0,
                                                            'system-primary-text-color opacity-40 cursor-not-allowed':
                                                                subscripeIndex == 0
                                                        }"
                                                    >
                                                        <!-- <i class="fas fa-minus"></i> -->
                                                        <IconMinusCircle />
                                                    </button>
                                                </div>
                                                <div class="plan-player text-4xl mx-3 font-bold">
                                                    <i class="fas fa-users mr-2 shadow-text-none"></i>
                                                    {{ !subscripeSelected ? '0' : subscripeSelected.player }}
                                                </div>
                                                <div v-if="!isTeacher">
                                                    <button
                                                        @click="
                                                            selectNext(
                                                                'subscripePriceText',
                                                                'subscripeIndex',
                                                                'subscripePlan',
                                                                interval
                                                            )
                                                        "
                                                        :class="{
                                                            'system-primary-text-color': true,
                                                            'text-3xl payment-control-btn': true,
                                                            'cursor-pointer':
                                                                subscripeIndex < subscripePlan[interval].length - 1,
                                                            'system-primary-text-color opacity-40 cursor-not-allowed':
                                                                subscripeIndex == subscripePlan[interval].length - 1
                                                        }"
                                                    >
                                                        <!-- <i class="fas fa-plus"></i> -->
                                                        <IconPlusCircle />
                                                    </button>
                                                </div>
                                            </div>
                                            <ul class="plan-list list-reset text-center">
                                                <li
                                                    class="text-sm md:text-base"
                                                    v-html="
                                                        isTeacher
                                                            ? $t('teacher_purchase_subscription_detail')
                                                            : $t('purchase_subscription_choice_detail')
                                                    "
                                                ></li>
                                            </ul>
                                        </div>
                                        <div
                                            class="text-3xl md:text-5xl mt-1 pb-1 mb-0 mx-0 text-center plan-title system-border-bottom"
                                        >
                                            <h3
                                                v-if="!isTeacher"
                                                class="m-0 price-text text-4xl shadow-text-none"
                                                ref="subscripePriceText"
                                            >
                                                <span v-if="checkable" class="text-old-price pr-3">
                                                    ${{ ((subscripeSelected.stripe.unit_amount / 100) * 2) / 12 }}
                                                </span>
                                                <!-- price month -->
                                                <span v-if="interval === 'month'">
                                                    ${{ subscripeSelected.stripe.unit_amount / 100 }}
                                                </span>
                                                <!-- price year -->
                                                <span v-else>
                                                    ${{ subscripeSelected.stripe.unit_amount / 100 / 12 }}
                                                </span>
                                                <span class="text-lg" style="font-weight: normal">
                                                    /
                                                    {{
                                                        interval === 'month'
                                                            ? $t('purchase_subscription_billed_month_interval')
                                                            : $t('purchase_subscription_billed_month_interval')
                                                    }}
                                                </span>
                                            </h3>
                                            <!-- teacher price -->
                                            <h3 v-else class="m-0 price-text text-4xl shadow-text-none">
                                                <span v-if="subscripeSelected.currency === 'USD'"
                                                    >${{ subscripeSelected.amount }}</span
                                                >
                                                <span v-else>{{ subscripeSelected.amount }}kr</span>

                                                <span class="text-lg" style="font-weight: normal">
                                                    /
                                                    {{
                                                        interval === 'month'
                                                            ? $t('purchase_subscription_billed_month_interval')
                                                            : $t('purchase_subscription_billed_year_interval')
                                                    }}
                                                </span>
                                            </h3>
                                        </div>
                                        <div :class="{ 'footer-area py-3 px-4': true }">
                                            <div class="flex items-center">
                                                <XToggleSwitch
                                                    @input="fetchSubscriptionPlan()"
                                                    :checked="checkable"
                                                    :show-background="true"
                                                    :show-toggle-symbol="false"
                                                    color="var(--ui-primary-color-alpha-40)"
                                                    border-color="var(--ui-primary-color)"
                                                    checked-color="var(--ui-primary-color)"
                                                    height="22"
                                                />
                                                <span v-if="!isTeacher" class="pl-2 text-sm shadow-text-none">
                                                    ${{
                                                        !checkable
                                                            ? ((subscripeSelected.stripe.unit_amount / 100) * 12) / 2
                                                            : subscripeSelected.stripe.unit_amount / 100
                                                    }}
                                                    {{ $t('purchase_subscription_billed_yearly') }}
                                                </span>
                                                <span v-else class="pl-2 text-sm shadow-text-none">
                                                    {{ $t('purchase_subscription_billed_yearly') }}
                                                </span>
                                            </div>
                                            <div class="offer-box">
                                                <div v-if="!checkable" class="flex justify-center items-baseline pr-10">
                                                    <ArrowDiscount />
                                                    <span class="pl-4 font-bold text-2xl shadow-text-none">
                                                        {{ $t('purchase_subscription_discount') }} {{isTeacher ? '71%' : '50%'}}
                                                    </span>
                                                </div>
                                                <div v-else class="flex justify-center items-baseline">
                                                    <span class="font-bold text-2xl shadow-text-none">
                                                        {{ $t('purchase_subscription_got_discount') }} {{isTeacher ? '71%' : '50%'}}
                                                    </span>
                                                </div>
                                                <div
                                                    class="font-semibold shadow-text-none px-3"
                                                    style="font-size: 14px"
                                                >
                                                    {{ $t('purchase_subscription_ai_description') }}
                                                </div>
                                            </div>

                                            <div class="flex flex-col">
                                                <!-- hidden button -->
                                                <button
                                                    v-if="geoLocation && geoLocation.code == 'NO'"
                                                    @click="setVippsModal('access', subscripeSelected, true)"
                                                    class="btn btn-outline btn-vipps w-full font-opensans font-size-15 mb-1 mt-4"
                                                    style="padding: 0.7rem 0"
                                                    type="button"
                                                >
                                                    {{ $t('purchase_button_vipps') }}
                                                </button>
                                                <form
                                                    @submit.prevent="subscribeByPaypal"
                                                    :action="agreementUrl"
                                                    method="post"
                                                >
                                                    <input name="id" :value="subscripeSelected.id" type="hidden" />
                                                    <input
                                                        name="plan_id"
                                                        :value="subscripeSelected.plan_id"
                                                        type="hidden"
                                                    />
                                                    <div class="relative">
                                                        <button
                                                            @click="
                                                                subscribeByStripe(
                                                                    'stripe' + subscripeIndex,
                                                                    subscripeSelected.stripe
                                                                )
                                                            "
                                                            class="btn btn-outline btn-stripe w-full font-opensans font-size-15 mb-1 relative"
                                                            style="padding: 0.7rem 0"
                                                            type="button"
                                                        >
                                                            {{ $t('purchase_button_stripe') }}
                                                        </button>
                                                    </div>
                                                    <button
                                                        class="btn btn-block btn-paypal text-sm font-opensans mb-1 flex justify-center items-center"
                                                    >
                                                        <PaypalLogo></PaypalLogo>
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="selectedPlan && !isTeacher"
                                    id="hour-access"
                                    class="flex hidden-tab flex-col w-full items-center justify-end col-xl-4 col-md-12 px-3 pb-3"
                                >
                                    <div class="highlight-mark invisible"></div>
                                    <div
                                        class="plan-item purchase-plan-block text-dark-charcoal w-full text-center system-border"
                                    >
                                        <h1 class="text-center text-2xl shadow-text-none mb-0 mt-2">
                                            {{ $t('purchase_header_24hour') }}
                                        </h1>
                                        <p
                                            class="text-center text-sm md:text-lg shadow-text-none mt-2 mb-3"
                                            v-html="$t('purchase_24hour_description')"
                                        ></p>
                                        <div
                                            class="flex flex-col w-full justify-center items-center px-2 py-1 plan-title system-border-top system-border-bottom"
                                        >
                                            <div class="flex">
                                                <div>
                                                    <button
                                                        @click="selectPrev('accessPriceText', 'accessIndex')"
                                                        :class="{
                                                            'system-primary-text-color': true,
                                                            'text-3xl payment-control-btn': true,
                                                            'cursor-pointer': !accessIndex == 0,
                                                            'system-primary-text-color opacity-40 cursor-not-allowed':
                                                                accessIndex == 0
                                                        }"
                                                    >
                                                        <!-- <i class="fas fa-minus"></i> -->
                                                        <IconMinusCircle />
                                                    </button>
                                                </div>
                                                <div class="plan-player text-4xl mx-3 font-bold">
                                                    <i class="fas fa-users mr-2 shadow-text-none"></i>
                                                    {{ selectedPlan.limitPlayer }}
                                                </div>
                                                <div>
                                                    <button
                                                        @click="selectNext('accessPriceText', 'accessIndex', 'plans')"
                                                        :class="{
                                                            'system-primary-text-color': true,
                                                            'text-3xl payment-control-btn': true,
                                                            'cursor-pointer': accessIndex < plans.length - 1,
                                                            'system-primary-text-color opacity-40 cursor-not-allowed':
                                                                accessIndex == plans.length - 1
                                                        }"
                                                    >
                                                        <!-- <i class="fas fa-plus"></i> -->
                                                        <IconPlusCircle />
                                                    </button>
                                                </div>
                                            </div>
                                            <ul class="plan-list list-reset text-center">
                                                <li
                                                    v-html="$t('purchase_24hour_number_player_description')"
                                                    class="text-sm md:text-base"
                                                ></li>
                                            </ul>
                                        </div>
                                        <div
                                            class="text-3xl md:text-5xl mt-1 pb-1 mb-0 mx-0 text-center plan-title system-border-bottom"
                                        >
                                            <h3 class="m-0 price-text text-4xl shadow-text-none" ref="accessPriceText">
                                                ${{ selectedPlan.price }}
                                                <span class="text-lg" style="font-weight: normal">
                                                    / {{ $t('purchase_24hour_hour') }}
                                                </span>
                                            </h3>
                                        </div>
                                        <div class="footer-area py-3 px-4">
                                            <div class="flex"></div>
                                            <div class="flex flex-col">
                                                <button
                                                    type="button"
                                                    class="btn btn-outline credit-btn w-full font-opensans font-size-15 mt-10 mb-1"
                                                    @click="paidByCredit"
                                                    :disabled="!isAblePayByCredit || isLoading"
                                                >
                                                    <span class="shadow-text-none">
                                                        {{ translate('purchase_button_credit') }}
                                                    </span>
                                                    <br />
                                                    <span
                                                        class="shadow-text-none font-thin font-size-11"
                                                        style="font-size: 11px"
                                                    >
                                                        {{
                                                            translate('purchase_24hour_user_credit', {
                                                                userCredits: creditFromState || credit,
                                                                s: creditFromState > 1 ? 's' : ''
                                                            })
                                                        }}
                                                    </span>
                                                </button>
                                                <button
                                                    v-if="geoLocation && geoLocation.code == 'NO'"
                                                    @click="setVippsModal('access', selectedPlan)"
                                                    class="btn btn-outline btn-vipps w-full font-opensans font-size-15 mb-1"
                                                    style="padding: 0.7rem 0"
                                                    type="button"
                                                >
                                                    {{ $t('purchase_button_vipps') }}
                                                </button>
                                                <button
                                                    @click="stripeOpen = true"
                                                    class="btn btn-outline btn-stripe w-full font-opensans font-size-15 relative"
                                                    style="padding: 0.7rem 0"
                                                    type="button"
                                                >
                                                    {{ $t('purchase_button_stripe') }}
                                                </button>
                                                <PaypalButton
                                                    class="mt-1"
                                                    @success="paidSuccess"
                                                    @creating="isLoading = true"
                                                    @cancel="isLoading = false"
                                                    @error="isLoading = false"
                                                    :price="selectedPlan.price"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="max-w-md m-auto">
                                <div class="text-center mt-2 mx-4">
                                    <p v-html="footerDescription" class="text-xs md:text-sm shadow-text-none mb-1"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <StripeCheckout
            @result="paidByStripe"
            @close="closeStripeModal"
            :open="stripeOpen"
            :title="translate('stripe_modal_description', { limitPlayer: selectedPlan.limitPlayer })"
            :perUnit="'24 hour'"
            :paymentDescription="'Upgrade players'"
            :amount="selectedPlan.price"
        />

        <VippsPayment
            @result="paidByVipps"
            @close="resetVipps"
            @subscription="onSubscription"
            :open="vippsData.status"
            :amount="vippsData.item ? vippsData.item.amount : 0"
            :title="vippsData.item ? vippsData.item.title : ''"
            :unit="vippsData.item ? vippsData.item.unit : ''"
            :unitText="vippsData.item ? vippsData.item.unit_text : ''"
            :is-subscription="isSubscriptionVipps"
            :vipps-data="vippsData"
        />
    </div>
</template>

<script>
import appConfig from '@/app.config'
import Request from '@/lib/request'
import { currentUser, getToken } from '@/lib/user'
import popup from '@/lib/popup'
import InnerLoader from '@/components/InnerLoader'
import PaypalButton from '@/components/PaypalButton'
import VippsPayment from '@/components/VippsPayment'
import StripeCheckout from '@/components/StripeCheckout'
import randomize from 'randomatic'
import UserService from '@/lib/user.js'
import helperMixin from '@/mixins/helper'
import helper from '@/lib/helper.js'
import IconPlusCircle from '../components/IconPlusCircle'
import IconMinusCircle from '../components/IconMinusCircle'
import ArrowDiscount from '../components/ArrowDiscount'
import XToggleSwitch from '@/components/v2/XToggleSwitch'
import PaypalLogo from '@/components/PaypalLogo'
import IntroHint from '@/lib/intro.js'
import { loadStripe } from '@stripe/stripe-js'
import NoPaymentOverlay from '@/components/NoPaymentOverlay'

const defaultSubscriptionPlan = function () {
    return {
        amount: 6,
        player: 20
    }
}

export default {
    name: 'PaymentPopup',

    components: {
        PaypalButton,
        InnerLoader,
        StripeCheckout,
        VippsPayment,
        IconPlusCircle,
        IconMinusCircle,
        XToggleSwitch,
        PaypalLogo,
        ArrowDiscount,
        NoPaymentOverlay
    },

    mixins: [helperMixin],

    props: {
        quizId: {
            type: String
        },
        paymentTitle: {
            type: String
        },
        paymentDescription: {
            type: String,
            default: ''
        },
        getCreditTrigger: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            stripeOpen: false,
            vippsOpen: false,
            showCloseButton: false,
            isLoading: false,
            geoLocation: null,
            selectedPlanIndex: 0,
            subscriptionPlans: [],
            selectedSubscription: defaultSubscriptionPlan(),
            credit: 0,
            vippsData: {
                status: false,
                item: {}
            },
            introHint: new IntroHint(),
            subscripeIndex: 0,
            accessIndex: 0,
            interval: 'year',
            checkable: true,
            subscripePlan: {
                month: [],
                year: []
            },
            publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
            isSubscriptionVipps: false,
            isShowSubscriptionPlan: true,
            innerWidth: ''
        }
    },

    watch: {
        getCreditTrigger: function () {
            this.getCredit()
        }
    },

    computed: {
        agreementUrl() {
            return `${appConfig.baseUrl}plans/agreement`
        },

        creditFromState() {
            return this.$store ? this.$store.state.credit : false
        },

        plans() {
            return appConfig.payPlayerPlans
        },

        selectedPlan() {
            if (this.plans.length > 0) {
                return this.plans[this.accessIndex]
            }
            return null
        },

        isFinalPlan() {
            return this.selectedPlanIndex + 1 == this.plans.length
        },

        isFirstPlan() {
            return this.selectedPlanIndex == 0
        },

        isAblePayByCredit() {
            return (this.creditFromState || this.credit) >= this.plans[this.selectedPlanIndex].price
        },

        subscripeSelected() {
            if (this.subscripePlan[this.interval].length > 0) {
                return this.subscripePlan[this.interval][this.subscripeIndex]
            }
            return null
        },

        description() {
            return this.paymentDescription + this.$t('purchase_header_upgrade_default_description')
        },

        isTeacher() {
            return this.isLoggedIn() && currentUser().role.includes('teacher')
        },

        isTeacherBasic() {
            return this.isLoggedIn() && currentUser().role === 'teacher'
        },

        isTeacherPlus() {
            return this.isLoggedIn() && currentUser().role === 'teacher_plus'
        },

        footerDescription() {
            if (!this.isLoggedIn()) {
                return this.$t('upgrade_modal_footer_description')
            }

            if (this.isTeacherBasic) {
                return this.$t('teacher_purchase_buy_access_school')
            }

            if (this.isTeacherPlus) {
                return ''
            }

            return this.$t('upgrade_modal_footer_description')
        }
    },

    mounted() {
        this.introHint.removeHints()

        const self = this

        // self.fetchSubscriptPlan()
        self.fetchSubscriptionPlan(true)

        const userService = new UserService()
        if (userService.isLoggedIn()) {
            self.getCredit()
        }

        self.getCurrentCountry()
    },

    methods: {
        fetchUpgrade(type) {
            this.isShowSubscriptionPlan = type == 'subscription' ? true : false
            const subscriptionBlock = document.getElementById(`subscription-plan`)
            const hourAccessBlock = document.getElementById(`hour-access`)

            if (type == 'subscription') {
                subscriptionBlock.classList.remove('hidden-tab')
                hourAccessBlock.classList.add('hidden-tab')
            } else {
                subscriptionBlock.classList.add('hidden-tab')
                hourAccessBlock.classList.remove('hidden-tab')
            }
        },

        animatePrice(refName) {
            this.$refs[refName].style.transform = 'scale(1.5)'

            setTimeout(() => {
                this.$refs[refName].style.transform = 'scale(1)'
            }, 400)
        },

        selectNext(refName, attribute, attribute2, subattribute2 = null) {
            var target = this[attribute2]

            if (subattribute2) {
                target = target[subattribute2]
            }

            if (this[attribute] + 1 >= target.length) {
                return
            }

            this.animatePrice(refName)
            this[attribute]++
        },

        selectPrev(refName, attribute) {
            if (this[attribute] <= 0) {
                return
            }

            this.animatePrice(refName)
            this[attribute]--
        },

        closeStripeModal() {
            this.stripeOpen = false
            this.closeModal()
        },

        closeVippsModal() {
            this.vippsOpen = false
            this.closeModal()
        },

        closeModal() {
            this.isLoading = false
            this.$emit('close')
        },

        closeByBackdrop(e) {
            if (this.isLoading) {
                return
            }

            if (!e.target.classList.contains('modal-backdrop')) {
                return
            }

            this.closeModal()
        },

        paidByVipps(status) {
            if (status == 'RESERVE') {
                this.$emit('success', status)
                this.trackPay('vipps', '24hrs_access')
                popup.alert(this.translate('purchase_alert_success'), function () {}, { icon: 'success' })
            } else {
                this.closeModal()
                popup.alert(this.translate('purchase_alert_fail'), function () {}, { icon: 'error' })
            }
        },

        paidSuccess(details) {
            const selected = this.plans[this.accessIndex]

            const payload = {
                order_id: details.id,
                payer_name: `${details.payer.name.given_name} ${details.payer.name.surname}`,
                payer_email: details.payer.email_address,
                payer_id: details.payer.payer_id,
                amount: details.purchase_units[0].amount.value,
                user_id: currentUser().id,
                method: 'paypal',
                data: {
                    limit_player: selected.limitPlayer
                },
                quiz_id: this.quizId
            }

            const request = new Request()

            request
                .post(appConfig.api.saveBuyPlayerOrder, payload)
                .then(() => {
                    this.closeModal()
                    this.$emit('success', payload)
                    this.trackPay('paypal', '24hrs_access')
                    popup.alert(this.translate('purchase_alert_success'), function () {}, { icon: 'success' })
                })
                .catch(() => {
                    this.closeModal()
                    popup.alert(this.translate('purchase_alert_fail'), function () {}, { icon: 'error' })
                })
        },

        paidByStripe(res) {
            if (res.status_code == 200) {
                const selected = this.plans[this.accessIndex]

                const payload = {
                    order_id: res.data.id,
                    payer_name: currentUser().name,
                    payer_email: currentUser().email,
                    payer_id: currentUser().id,
                    amount: parseFloat(res.data.amount / 100).toFixed(2),
                    user_id: currentUser().id,
                    method: res.data.method,
                    data: {
                        limit_player: selected.limitPlayer
                    },
                    quiz_id: this.quizId
                }

                const request = new Request()

                request
                    .post(appConfig.api.saveBuyPlayerOrder, payload)
                    .then(() => {
                        this.closeStripeModal()
                        this.$emit('success', payload)
                        this.trackPay('stripe', '24hrs_access')
                        popup.alert(this.translate('purchase_alert_success'), function () {}, { icon: 'success' })
                    })
                    .catch(() => {
                        this.closeStripeModal()
                        popup.alert(this.translate('purchase_alert_fail'), function () {}, { icon: 'error' })
                    })
            } else {
                this.closeStripeModal()
                popup.alert(this.translate('purchase_alert_fail'), function () {}, { icon: 'error' })
            }
        },

        paidByCredit() {
            const selected = this.plans[this.accessIndex]

            const payload = {
                order_id: randomize('A0', 17),
                payer_name: currentUser().name,
                payer_email: currentUser().email,
                payer_id: currentUser().id,
                amount: parseFloat(selected.price).toFixed(2),
                user_id: currentUser().id,
                method: 'credit',
                data: {
                    limit_player: selected.limitPlayer
                },
                quiz_id: this.quizId
            }

            if (this.isAblePayByCredit) {
                const request = new Request()

                this.isLoading = true

                request
                    .post(appConfig.api.saveBuyPlayerOrder, payload)
                    .then(() => {
                        this.closeModal()
                        this.$emit('success', payload)
                        popup.alert(this.translate('purchase_alert_success'), function () {}, { icon: 'success' })

                        if (this.$store) {
                            this.$store.dispatch('getCredit')
                        }
                    })
                    .catch(() => {
                        this.closeModal()
                        popup.alert(this.translate('purchase_alert_fail'), function () {}, { icon: 'error' })
                    })
            }
        },

        findSubscriptionPlan(selectBuyPlan) {
            const found = this.subscriptionPlans.find(plan => {
                return plan.player == selectBuyPlan.limitPlayer
            })

            if (found) {
                this.selectedSubscription = {
                    amount: found.amount,
                    player: found.player
                }
            } else {
                this.selectedSubscription = defaultSubscriptionPlan()
            }
        },

        fetchSubscriptPlan() {
            const request = new Request()

            this.isLoading = true

            var condition = {
                recurring: {
                    interval: 'month'
                }
            }

            request
                .post(appConfig.api.getSubscriptionPlan, condition)
                .then(res => {
                    this.subscriptionPlans = res.data.data
                    this.isLoading = false
                })
                .catch(() => {
                    this.isLoading = false
                })
        },

        isLoggedIn() {
            const userService = new UserService()
            return userService.isLoggedIn()
        },

        getCredit() {
            if (!this.$store) {
                const userService = new UserService()
                const token = userService.getToken()
                const request = new Request({
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
                const url = appConfig.api.getCredit.replace('__id__', userService.getUser().id)

                request
                    .get(url)
                    .then(res => {
                        this.credit = res.data.data ? res.data.data.credit : 0
                        this.credit = parseFloat(this.credit.toFixed(2))
                    })
                    .catch(() => {})

                return
            }

            if (this.isLoggedIn()) {
                this.$store.dispatch('getCredit')
            }
        },

        getCurrentCountry() {
            if (this.$store) {
                return this.$store.dispatch('getCurrentCountry').then(res => {
                    this.geoLocation = res.data.data
                })
            }

            const request = new Request()
            const url = appConfig.api.getUserCountry

            request.get(url).then(res => {
                this.geoLocation = res.data.data
            })
        },

        trackPay(payment, label) {
            helper.gTrackEvent('payed', {
                event_category: `Payed_${payment}`,
                event_label: `Pay_${label}_at_payment_popup`
            })
        },

        fetchSubscriptionPlan(firstLoad = null) {
            this.isLoading = true
            let interval = this.interval

            if (!firstLoad) {
                interval = this.interval === 'month' ? 'year' : 'month'
            }

            const condition = {
                recurring: {
                    interval: interval
                }
            }

            if (this.subscripePlan[condition.recurring.interval].length == 0) {
                const request = new Request()

                const headers = this.isLoggedIn()
                    ? {
                          Authorization: `Bearer ${getToken()}`
                      }
                    : {}

                request
                    .post(appConfig.api.getSubscriptionPlan, condition, {
                        headers
                    })
                    .then(res => {
                        this.subscripePlan[condition.recurring.interval] = res.data.data
                        this.interval = interval
                        this.checkable = interval === 'year'
                        this.isLoading = false
                    })
                    .catch(() => {})
            } else {
                this.interval = interval
                this.checkable = interval === 'year'
                this.isLoading = false
            }
        },

        setVippsModal(target, data, isSubscription = false) {
            if (this.isTeacherPlus) {
                return
            }

            var payload = {
                amount: !isSubscription ? data.priceKr : data.nok_amount
            }

            if (target == 'access') {
                if (isSubscription) {
                    payload['title'] = this.$t('vipps_modal_description', { limitPlayer: data.player })
                    payload['interval'] = {
                        unit: this.interval.toUpperCase(),
                        count: 1
                    }
                    payload['limitPlayer'] = data.player
                    payload['payment_on'] = 'access'
                    payload['plan_id'] = data.plan_id
                } else {
                    payload['title'] = this.$t('vipps_modal_description', { limitPlayer: data.limitPlayer })
                    payload['unit'] = '24 hours'
                    payload['unit_text'] = this.$t('vipps_modal_unit_24hour')
                    payload['payment_on'] = 'access'
                }
            }

            if (target == 'credit') {
                payload['title'] = ''
                payload['unit'] = `${data.credit} credit(s)`
                payload['unit_text'] = this.$t('vipps_modal_unit_pay_as_you_go', {
                    credit: data.credit,
                    s: data.credit > 1 ? 's' : ''
                })
                payload['payment_on'] = 'credit'
            }

            this.isSubscriptionVipps = isSubscription

            this.vippsData = {
                status: true,
                item: payload
            }
        },

        resetVipps() {
            this.vippsData = {
                status: false,
                item: null
            }
        },

        onSubscription(type) {
            this.isSubscriptionVipps = type
        },

        subscribeByStripe(refKey, payload) {
            if (this.isTeacherPlus) {
                return
            }

            this.isLoading = true

            const request = new Request()
            const plan = payload

            plan['user_id'] = currentUser().id
            plan['track'] = randomize('A0', 17)
            plan['campaign_id'] = ''

            request.post(appConfig.api.stripeCreateSession, payload).then(res => {
                if (res.data.message == 'create_session_success') {
                    const session = res.data.data

                    Promise.resolve(loadStripe(this.publicKey)).then(stripe => {
                        stripe.redirectToCheckout({
                            sessionId: session.id
                        })

                        this.isLoading = false
                    })
                }
            })
        },

        subscribeByPaypal(e) {
            if (this.isTeacherPlus) {
                return
            }

            this.isLoading = true

            e.target.submit()

            setTimeout(() => {
                this.isLoading = false
            }, 2000)
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/modal.scss';

$input-border-color: #cbcbcb;
$input-border-darker-color: #b6b6b6;

#payment-popup-modal {
    .auth-popup-header {
        &.payment-popup-header {
            margin-bottom: 1rem;

            @media screen and (max-width: 719px) {
                margin-bottom: 1rem;
            }
        }
    }

    .modal-body {
        padding-bottom: 10px !important;

        @media screen and (max-width: 719px) {
            padding-bottom: 20px !important;
        }
    }

    .modal-backdrop {
        background-color: rgba(0, 0, 0, 0.2);
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.5rem;
        z-index: 9999;
        overflow: auto;
        padding-bottom: 0;
        padding-top: 0;

        .modal-content {
            background-color: #fff;
            // margin-top: 4rem;
            height: 94vh;
            padding: 1rem;
            min-width: 720px;
            overflow: hidden;
            border-radius: 3px;
            box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.6);

            @media screen and (max-width: 719px) {
                min-width: 90%;
                height: 86vh;
                margin: 1rem 0.5rem;
            }

            @media screen and (min-height: 900px) {
                height: auto;
            }

            .modal-body {
                margin: 0 0 0 0;
                overflow-y: scroll;

                @media screen and (max-width: 719px) {
                    margin: 0 0 1rem 0;
                }
            }
        }
    }

    .plan-block {
        @include plan-block-modal;
    }
    .btn-outline {
        @include btn-outline;
    }

    .btn {
        border-radius: 4px;
    }

    .auth-modal .btn-outline,
    .btn.btn-outline {
        border: 0;
    }

    .btn-stripe {
        @include btn-stripe;
    }

    .btn-vipps {
        @include btn-vipps;
    }

    .highlight-mark {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.5rem;
        font-weight: bold;
        max-width: 320px;
        width: 80%;
        height: 2.6rem;
        background-color: rgba(255, 194, 49, 1);
        border-radius: 0.5rem 0.5rem 0 0;

        @media screen and (max-width: 767px) {
            font-size: 1.2rem;
        }
    }

    .text-old-price {
        display: inline-block;
        text-decoration: line-through;
        text-decoration-color: #f61811;
        text-decoration-thickness: 4px;
    }

    .footer-area {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 18rem;

        .offer-box {
            color: #3e9d03;
        }

        &.min-h-custom {
            min-height: 14.5rem;
        }
    }

    .font-semibold {
        font-weight: 600;
    }

    .btn-group {
        border-radius: 0.5rem;
        overflow: hidden;
        display: inline-block;
        border: 2px solid var(--ui-primary-color);

        > a {
            // color: var(--text-color);
            padding: 7px 15px;
            display: inline-block;
            cursor: pointer;

            span,
            i {
                text-shadow: var(--text-shadow) !important;
            }

            > span {
                transition: 0.3s;
            }

            > div {
                transition: transform 0.3s;
            }

            &:hover {
                > div {
                    transform: translateY(-2px);
                }
            }

            &.active {
                background-color: var(--ui-primary-color);
                color: var(--ui-secondary-color);
            }
        }
    }

    #btn-group-mobile {
        display: none;

        @media screen and (max-width: 767px) {
            display: flex;
            justify-content: center;
        }

        a {
            column-gap: 8px;
        }
    }

    #d-group-access {
        justify-content: center;

        #hour-access {
            @media screen and (max-width: 767px) {
                width: 60%;
            }

            @media screen and (min-width: 768px) {
                display: flex;
            }
        }

        #subscription-plan {
            @media screen and (max-width: 767px) {
                width: 60%;
            }
        }

        .hidden-tab {
            display: none;

            @media screen and (min-width: 767px) {
                display: flex;
            }
        }
    }

    @media (max-width: 575px) {
        .btn-group {
            display: flex;

            a {
                width: 100%;
                max-width: calc(100% / 3);
                padding: 7px 5px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        #btn-group-mobile {
            .btn-group a {
                max-width: calc(100% / 2);
                width: 150px;
            }
        }
        #subscription-plan {
            width: 100% !important;

            .disabled-plan {
                filter: blur(3px);
                user-select: none;
                pointer-events: none;
            }
        }

        #hour-access {
            width: 100% !important;
        }
    }

    .max-w-teacher {
        max-width: 26rem;

        @media screen and (max-width: 767px) {
            max-width: unset;
        }
    }

    .plan-player,
    .price-text {
        font-size: 2rem;
    }
}
</style>
